import React from 'react'
import { FormDashboardLabel as Label } from './label'
import { InputPrefix } from './input-prefix'

const LinkAdder = ({prefix, label, defaultValue, defaultState = false, ...props}) => {
  const [isAdding, setIsAdding] = React.useState(defaultState)

  return (
    <div {...props}>
      {
        isAdding &&
        <React.Fragment>
          <Label>{label}</Label>
          <InputPrefix
            prefix={prefix}
            removable
            onRemove={() => setIsAdding(false)}
            defaultValue={defaultValue}
          />
        </React.Fragment>
      }
      {
        !isAdding &&
        <div className="flex items-center justify-between lg:justify-start">
          <p className="text-sm font-bold lg:w-1/4">{label}</p>
          <p className="link" onClick={() => setIsAdding(true)}>Add</p>
        </div>
      }
    </div>
  )
}

export { LinkAdder }